import { render } from "./ScanReturnPage.vue?vue&type=template&id=1e8f46d5&ts=true"
import script from "./ScanReturnPage.vue?vue&type=script&lang=ts"
export * from "./ScanReturnPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__